import PropTypes from 'prop-types';
import React from 'react';

import { rapPermissions } from '../../utils/tab-permissions';
import { PageTemplate } from '../reusable';

import { KB_URL } from './constants';
import Main from './main';

const RAPDevOpsUserSetup = ({ location }) => (
  <PageTemplate
    auth={rapPermissions}
    description="Provision DevOps user access across one or more stores."
    help={(
      <a
        className="ncss-cta-primary-dark underline text-color-secondary"
        href={KB_URL}
        rel="noopener noreferrer"
        target="_blank"
      >
        Click here to view the KB
      </a>
    )}
    page={<Main />}
    path={location.pathname}
    title="DevOps User Setup"
  />
);

RAPDevOpsUserSetup.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired,
};

export default RAPDevOpsUserSetup;
